import { render, staticRenderFns } from "./grant-stat.vue?vue&type=template&id=f0a6f24e&scoped=true&"
import script from "./grant-stat.vue?vue&type=script&lang=js&"
export * from "./grant-stat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0a6f24e",
  null
  
)

export default component.exports